(() => {
  'use strict';
  if (customElements.get('luminia-invoice-trigger')) return;
  const dialog = document.getElementById('li-invoice-dialog');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const error = dialog.querySelector('[role="alert"]');
  const save = dialog.querySelector('[data-li-save]');
  const remove = dialog.querySelector('[data-li-remove]');
  const root = dialog.dataset.cartRoot.replace(/\/?$/, '/');
  const keys = ['invoice','invoice-type','country','fiscal-code','company-name','vat','sdi','pec'];
  const controls = ['country','fiscal-code','company-name','vat','sdi','pec'];
  const field = name => form.elements.namedItem(name);
  let saved = null;
  let busy = false;
  let loaded = false;
  let opener = null;
  const codes = 'AF AL DZ UM AD AO AI AG SA AR AM AW AU AT AZ BS BH BD BB BE BZ BJ BM BT BY BO BA BW BR BN BG BF BI KH CM CA CV BQ CZ TD CL CN CY VA CO KM CD CG KR CR CI HR CW DK DM EC EG SV AE ER EE ET FJ PH FI FR GA GM GE GS DE GH JM JP GI DJ JO GR GD GL GP GT GG GN GQ GW GY GF HT HN IN ID IQ IE IS AC CX NF IM AX KY CC CK FO FK PN SB TC VG IL IT JE KZ KE KG KI XK KW LA LS LV LB LR LY LI LT LU MK MG MW MY MV ML MT MA MQ MR MU YT MX MD MC MN ME MS MZ MM NA NR NP NI NE NG NU NO NC NZ OM NL PK PA PG PY PE PF PL PT QA HK MO GB CF DO RE RO RW RU EH KN LC MF VC BL PM WS SM SH ST SN RS SC SL SG SX SK SI SO ES LK US SS ZA SD SR SJ SE CH TJ TW TZ TF PS IO TH TL TG TK TO TT TA TN TR TM TV UA UG HU UY UZ VU VE VN WF YE ZM ZW SZ'.split(' ');
  const names = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['it'], {type:'region'}) : null;
  codes.map(code => ({code,label:names ? names.of(code) : code})).sort((a,b)=>a.label.localeCompare(b.label,'it')).forEach(({code,label})=>field('country').add(new Option(label,code)));

  function showError(message) { error.textContent = message; error.hidden = !message; }
  function setBusy(value) {
    busy = value;
    form.setAttribute('aria-busy',String(value));
    form.querySelectorAll('button').forEach(button=>button.disabled=value);
    form.querySelectorAll('input,select').forEach(input=>input.disabled=value);
    save.textContent = value ? 'Attendi...' : 'Salva';
    if (!value) updateFields();
  }
  function updateFields() {
    const company = field('invoice-type').value === 'Azienda';
    dialog.querySelectorAll('[data-li-company]').forEach(container=>{
      const visible = company && (!container.hasAttribute('data-li-italy') || field('country').value === 'IT');
      container.hidden = !visible;
      container.querySelectorAll('input,select').forEach(input=>{
        input.disabled = busy || !visible;
        input.required = visible && ['country','company-name','vat'].includes(input.name);
      });
    });
  }
  function populate(attributes) {
    field('invoice-type').value = attributes['invoice-type'] === 'Privato' ? 'Privato' : 'Azienda';
    controls.forEach(name=>{field(name).value=attributes[name] || '';field(name).removeAttribute('aria-invalid');field(name).setCustomValidity('');});
    remove.hidden = attributes.invoice !== 'yes';
    updateFields();
  }
  function updateTriggers() {
    document.querySelectorAll('luminia-invoice-trigger').forEach(trigger=>trigger.render());
  }
  function close() {
    if (busy) return;
    dialog.close();
  }
  dialog.addEventListener('close',()=>{
    document.documentElement.classList.remove('li-invoice-open');
    if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  dialog.querySelector('[data-li-close]').addEventListener('click',close);
  form.addEventListener('change',updateFields);
  form.addEventListener('input',event=>{
    if (event.target.setCustomValidity) {event.target.setCustomValidity('');event.target.removeAttribute('aria-invalid');}
    showError('');
  });
  async function request(endpoint, options={}) {
    const response = await fetch(root+endpoint,{credentials:'same-origin',cache:'no-store',...options,signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    if (!cart.attributes || cart.errors) throw new Error('Unexpected cart response');
    return cart.attributes;
  }
  async function open(button) {
    if (busy) return;
    opener = button;
    loaded = false;
    showError('');
    populate(saved || {});
    dialog.showModal();
    document.documentElement.classList.add('li-invoice-open');
    setBusy(true);
    try {
      saved = await request('cart.js');
      loaded = true;
      populate(saved);
      updateTriggers();
    } catch {
      showError('Impossibile caricare i dati. Chiudi e riprova prima di modificarli.');
      setBusy(false);
      save.disabled = true;
      remove.disabled = true;
      return;
    }
    setBusy(false);
    form.querySelector('input[name="invoice-type"]:checked').focus();
  }
  function payload() {
    // Only the established invoice keys are written; all other cart attributes and notes stay intact.
    const values = Object.fromEntries(keys.map(key=>[key,'']));
    values.invoice = 'yes';
    values['invoice-type'] = field('invoice-type').value;
    controls.forEach(name=>{if(!field(name).disabled)values[name]=field(name).value.trim();});
    ['fiscal-code','vat','sdi'].forEach(name=>values[name]=values[name].replace(/\s/g,'').toUpperCase());
    return values;
  }
  function validate(values) {
    controls.forEach(name=>{field(name).setCustomValidity('');field(name).removeAttribute('aria-invalid');});
    const italian = values['invoice-type']==='Privato' || values.country==='IT';
    if (italian && !/^(?:[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]|[0-9]{11})$/.test(values['fiscal-code'])) {
      field('fiscal-code').setCustomValidity('Inserisci un codice fiscale di 16 caratteri o 11 cifre.');
    }
    if (values['invoice-type']==='Azienda' && values.country==='IT' && !/^(?:IT)?[0-9]{11}$/.test(values.vat)) {
      field('vat').setCustomValidity('Inserisci una partita IVA di 11 cifre, eventualmente preceduta da IT.');
    }
    const invalid = controls.map(field).find(input=>!input.disabled&&!input.checkValidity());
    if (invalid) {
      let message=invalid.validationMessage;
      if(invalid.validity.valueMissing)message=invalid.tagName==='SELECT'?'Seleziona la nazione.':'Compila questo campo.';
      else if(invalid.validity.typeMismatch)message='Inserisci un indirizzo PEC nel formato nome@dominio.it.';
      else if(invalid.validity.patternMismatch)message='Il Codice SDI deve contenere 7 lettere o cifre.';
      invalid.setCustomValidity(message);
      invalid.setAttribute('aria-invalid','true');showError(message);invalid.reportValidity();return false;
    }
    return true;
  }
  async function persist(values) {
    setBusy(true);showError('');
    try {
      const attributes=await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:values})});
      if (!keys.every(key=>(attributes[key]||'')===values[key])) throw new Error('Invoice values not confirmed');
      saved=attributes;
      updateTriggers();
      setBusy(false);
      close();
    } catch {
      setBusy(false);
      showError('Salvataggio non confermato. Controlla la connessione e premi di nuovo Salva.');
    }
  }
  form.addEventListener('submit',event=>{
    event.preventDefault();
    if(busy || !loaded)return;
    const values=payload();
    if(validate(values))persist(values);
  });
  remove.addEventListener('click',()=>{if(!busy && loaded)persist(Object.fromEntries(keys.map(key=>[key,''])));});
  class InvoiceTrigger extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.button=this.querySelector('[data-li-open]');
      this.recap=this.querySelector('[data-li-recap]');
      this.initial=JSON.parse(this.querySelector('[data-li-initial]').textContent);
      this.button.disabled=false;
      this.button.addEventListener('click',()=>open(this.button));
      this.render();
    }
    render() {
      if(!this.button)return;
      const attributes=saved || this.initial;
      const enabled=attributes.invoice==='yes';
      this.button.textContent=enabled?'Modifica dati di fatturazione':'Richiedi la fattura';
      this.recap.hidden=!enabled;
      this.recap.textContent=enabled?'Fattura richiesta: '+(attributes['invoice-type']||''):'';
    }
  }
  customElements.define('luminia-invoice-trigger',InvoiceTrigger);
})();
